import { getMartData } from "api/ApiCalls"
import { applyFetcherOptions } from "helpers/martHelpers"
import { type MartFetcherOptions } from "types/ApiTypes"
import type { IServerSideGetRowsRequest } from "@tokenterminal/ui/DataTable"

const DATASET_TABLE = `insider_transactions`

const PLAIN_SSRM_REQUEST: IServerSideGetRowsRequest = {
  startRow: 0,
  endRow: 100,
  valueCols: [],
  pivotCols: [],
  rowGroupCols: [],
  pivotMode: false,
  groupKeys: [],
  filterModel: {},
  sortModel: [],
}

const DEFAULT_SSRM_REQUEST: IServerSideGetRowsRequest = {
  ...PLAIN_SSRM_REQUEST,
  sortModel: [
    {
      sort: "desc",
      colId: "timestamp",
    },
  ],
}

type InsiderTransactionsDataBQ = {
  market_sector_id: string | null
  market_sector_name: string | null
  chain_id: string | null
  chain_dbt_tag: string | null
  chain_name: string | null
  project_id: string | null
  project_dbt_tag: string | null
  project_name: string | null
  token_standard: string | null
  token_symbol: string | null
  token_address: string | null
  timestamp: string | null
  timestamp_grain: string | null
  transaction_hash: string | null
  transaction_type: string | null
  dex: string | null
  action_type: string | null
  quantity: number | null
  usd_value: number | null
  usd_flow: number | null
  from_address: string | null
  to_address: string | null
}

// Export uses this. there's a TODO To remove
export async function getInsiderTransactionData<
  T = Array<InsiderTransactionsDataBQ>,
>(
  body: IServerSideGetRowsRequest = DEFAULT_SSRM_REQUEST,
  opts?: MartFetcherOptions
) {
  if (opts) {
    applyFetcherOptions(body, opts)
  }

  const martData = await getMartData<T>(DATASET_TABLE, body)

  return martData.data
}
